import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import Select from "react-select";
import qs from "qs";
import { updateRestaurantNameSchema } from "../../../../validations";
import {
	useGetAllCuisine,
	useUpdateRestaurant,
	useGetRestaurantDetails,
} from "../../../../queryHooks";
import { useStore } from "../../../../zustand/store";
import CS from "../../../../services/commonService";
import dataUrlToFile from "../../../common/urlToFile";
import UploadAndCropImageModal from "../../../common/UploadAndCropImageModal";

const priceRangeOptions = [
	{ label: "$", value: "1" },
	{ label: "$$", value: "2" },
	{ label: "$$$", value: "3" },
	{ label: "$$$$", value: "4" },
];

const BasicDetails = () => {
	const setLoading = useStore((state) => state.setLoading);
	const { slug } = useParams();
	const [newphoto, setNewPhoto] = useState();
	const [cropAndUploadImageModel, setCropAndUploadImageModel] = useState(false);
	const [file, setFileData] = useState();
	const [cuisineOptions, setCuisineOptions] = useState([]);
	const [activeCuisines, setActiveCuisines] = useState([]);
	const [priceRange, setPriceRange] = useState(null);

	const { data: dataRestaurantDetails, refetch } =
		useGetRestaurantDetails(slug);

	useEffect(() => {
		if (dataRestaurantDetails && dataRestaurantDetails?.status === "success") {
			const _activeCuisines = dataRestaurantDetails.data?.cuisines?.map(
				(cuisine) => {
					return { label: cuisine.name, value: cuisine.cuisine_id };
				}
			);
			setActiveCuisines(_activeCuisines);
			let priceRangeLabel = priceRangeOptions.filter(
				(option) => option.value === dataRestaurantDetails.data?.price_range
			);
			priceRangeLabel = priceRangeLabel?.[0].label || "Select amount range";
			setPriceRange({
				label: priceRangeLabel,
				value: dataRestaurantDetails.data?.price_range || "",
			});
			setNewPhoto(dataRestaurantDetails.data?.profile_image_url);
		}
	}, [dataRestaurantDetails]);

	const { data: dataGetCuisines } = useGetAllCuisine(
		qs.stringify({
			filter: { ["is_active"]: true },
		})
	);

	useEffect(() => {
		if (dataGetCuisines && dataGetCuisines.status === "success") {
			const resultData = dataGetCuisines.data?.data?.records?.map(
				(cuisine) => ({
					label: cuisine.name,
					value: cuisine.cuisine_id,
				})
			);
			setCuisineOptions(resultData);
		}
	}, [dataGetCuisines]);

	const {
		mutateAsync: updateRestaurant,
		error: errorUpdateRestaurant,
		data: dataUpdateRestaurant,
		isLoading: loadingUpdateRestaurant,
	} = useUpdateRestaurant();

	useEffect(() => {
		if (dataUpdateRestaurant) {
			if (dataUpdateRestaurant.status === "success") {
				CS.showSuccessMessage(dataUpdateRestaurant.message);
				refetch();
			} else if (dataUpdateRestaurant.status === "fail") {
				CS.showErrorMessage(dataUpdateRestaurant.message);
			}
		}
	}, [dataUpdateRestaurant]);

	useEffect(() => {
		if (errorUpdateRestaurant) {
			CS.showErrorMessage(errorUpdateRestaurant.response?.data?.message);
		}
	}, [errorUpdateRestaurant]);

	//handle image cropped function
	const handleImageCropped = async (image) => {
		if (image) {
			const fileObj = dataUrlToFile(image);
			setFileData(fileObj);
			setNewPhoto(image);
		}
	};

	const changeCuisineHandler = (val) => {
		if (val.length < 4) {
			setActiveCuisines(val);
		}
	};

	const {
		values: valuesBasic,
		errors: errorsBasic,
		handleChange: handleChangeBasic,
		handleSubmit: handleSubmitBasic,
		touched: touchedBasic,
	} = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataRestaurantDetails?.data?.name || "",
		},
		validationSchema: updateRestaurantNameSchema,
		onSubmit: (value) => {
			const selectedCuisineIds = activeCuisines.map((item) => item.value);
			const _formData = new FormData();
			_formData.append("name", value.name?.trim());
			selectedCuisineIds.forEach((id) => _formData.append("cuisine_id[]", id));
			_formData.append("price_range", priceRange.value);
			if (file) {
				_formData.append("profile_picture", file);
			}
			updateRestaurant({
				id: slug,
				fileData: _formData,
			});
		},
	});

	useEffect(() => {
		setLoading(loadingUpdateRestaurant);
	}, [loadingUpdateRestaurant]);

	return (
		<>
			<form onSubmit={handleSubmitBasic}>
				<div className="card restaurant-card mb-5">
					<div className="modal-header p-0 pb-3 mb-4 w-100">
						<h5 className="box-title modal-title">
							<i className="bx bx-user mr-1"></i> Restaurant Info
						</h5>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="row align-items-end">
								<div className="col-md-12">
									<div
										className="user-title-info user-details"
										style={{
											display: "flex",
											justifyContent: "space-between",
										}}
									>
										<div className="col-md-2 mb-3">
											<div className="edit-image ml-0">
												<div className="user-image">
													<div>
														<div
															onClick={() => setCropAndUploadImageModel(true)}
														>
															{CS.renderImageUrl(newphoto || "")}
														</div>
													</div>
													<label
														className="img-upload"
														htmlFor="attach-file"
														onClick={() => setCropAndUploadImageModel(true)}
													>
														<em className="bx bxs-edit-alt" />
													</label>
													<UploadAndCropImageModal
														show={cropAndUploadImageModel}
														handleImageCropped={handleImageCropped}
														handleClose={() =>
															setCropAndUploadImageModel(false)
														}
													/>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="restaurantName">
													Restaurant Name
													<sup className="text-danger">*</sup>
												</label>
												<div className="w-100">
													<input
														maxLength="255"
														type="text"
														className="form-control"
														id="name"
														name="name"
														placeholder="Enter restaurant name"
														value={valuesBasic.name}
														onChange={handleChangeBasic}
													/>
													<span className="text-danger d-block">
														{errorsBasic.name && touchedBasic.name
															? errorsBasic.name
															: null}
													</span>
												</div>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label
													className="mb-0"
													htmlFor="cuisines"
													style={{ width: "auto" }}
												>
													Cuisines (Select up to 3)
												</label>
												<div className="w-100">
													<Select
														className="default-select"
														value={activeCuisines}
														options={cuisineOptions}
														isMulti={true}
														searchable={true}
														placeholder="Select cuisines"
														onChange={(val) => changeCuisineHandler(val)}
													/>
												</div>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="restaurantName">
													Amount Range
												</label>
												<div className="w-100">
													<Select
														className="default-select"
														value={priceRange}
														options={priceRangeOptions}
														searchable={true}
														placeholder="Select price range"
														onChange={(val) => setPriceRange(val)}
													/>
												</div>
											</div>
											<div className="col-md-12 mt-4 btn-blocks text-right">
												<button className="btn btn-primary glow-primary mr-4">
													Save Changes
												</button>
												<Link
													className="btn btn-outline-primary"
													to={`${URL.restaurants}/${slug}`}
												>
													Cancel
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</>
	);
};

export default BasicDetails;
